<template>
    <div class="dayin">
        <div class="leftdiv">
            <div  v-for="(itemcon,index) in layoutcontent" :key="itemcon.key" 
            :class="['divkey',{checked:!itemcon.show}]"
            @click="setDayin(itemcon,index)"
            >{{itemcon.title}}
            </div> 
        </div>
        <div class="layout">
            <grid-layout
                :layout.sync="layout"
                :col-num="colNum"
                :row-height="40"
                :is-draggable="true"
                :is-resizable="true"
                :vertical-compact="verticalCompact"
                :margin="[5, 5]"
                :use-css-transforms="false"
                class="hoverStyle">
                <grid-item v-for="(item,index) in layout" :key="item.i"
                        :x="item.x"
                        :y="item.y"
                        :w="item.w"
                        :h="item.h"
                        :i="item.i"
                        :class="item.class"
                        >
                    <div v-html="item.title+item.value"></div>
                    <div class="del" @click="delDayin(item,index)">X</div>
                </grid-item>
            </grid-layout> 
        </div>
    </div>
    
</template>

<script>
import VueGridLayout from 'vue-grid-layout';

export default {
    components: {
        GridLayout: VueGridLayout.GridLayout,
        GridItem: VueGridLayout.GridItem
    },
    data(){
        return {
            layoutmoren: [
                {"x":6,"y":0,"w":12,"h":1,"i":"jdmc",title:'',value: this.$store.state.hotelInfo.cname,class:'hotelname'},
                {"x":6,"y":1,"w":12,"h":1,"i":"djmc",title:'',value:'预付款单',class:'hotelname'},
                {"x":18,"y":1,"w":6,"h":1,"i":"sj",title:'',value:'2021年10月01日',class:'hotelname'},    

                
                {"x":0,"y":2,"w":8,"h":1,"i":"bkxm",title:'宾客姓名：',value:'吕之明',class:'content'},
                {"x":8,"y":2,"w":8,"h":1,"i":"xb",title:'性别：',value:'男',class:'content'},    
                {"x":16,"y":2,"w":8,"h":1,"i":"sfz",title:'身份证：',value:'320124198705192418',class:'content'},  
                
                {"x":0,"y":3,"w":24,"h":1,"i":"jtzz",title:'家庭住址：',value:'江苏省 南京市 溧水区 何凤镇 孔镇村 大王埂村51号',class:'content'}, 
                
                
                {"x":0,"y":4,"w":6,"h":1,"i":"fjhm",title:'房间号码：',value:'8888',class:'content'},
                {"x":6,"y":4,"w":6,"h":1,"i":"fj",title:'房价：',value:'888.00',class:'content'},    
                {"x":12,"y":4,"w":6,"h":1,"i":"fx",title:'房型：',value:'豪华套房',class:'content'}, 
                {"x":18,"y":4,"w":6,"h":1,"i":"yflx",title:'用房类型：',value:'内用',class:'content'},  


                {"x":0,"y":5,"w":12,"h":1,"i":"rzsj",title:'入住时间：',value:'2021年10月01日',class:'content'},
                {"x":12,"y":5,"w":12,"h":1,"i":"tfsj",title:'退房时间>',value:'2021年10月03日',class:'content'},  
                
                {"x":0,"y":6,"w":6,"h":1,"i":"fkfs",title:'付款方式：',value:'现金',class:'content'},
                {"x":6,"y":6,"w":6,"h":1,"i":"je",title:'金额：',value:'888.00',class:'content'},    
                {"x":12,"y":6,"w":6,"h":1,"i":"dh",title:'单号：',value:'131521354',class:'content'}, 
                {"x":18,"y":6,"w":6,"h":1,"i":"syy",title:'收银员：',value:'张三三',class:'content'},  

                {"x":0,"y":7,"w":24,"h":1,"i":"txfh",title:'同行房号：',value:'8881 8882 8883 8884 8885',class:'content'}, 

                {"x":0,"y":8,"w":24,"h":1,"i":"bz",title:'备注：',value:'没什么好说的',class:'content'}, 

                {"x":0,"y":8,"w":14,"h":4,"i":"yqtx",title:'友情提醒：',value:'123123123123213<br>13123123123',class:'content'},
                {"x":14,"y":8,"w":10,"h":4,"i":"bkqz",title:'宾客签字：',value:'',class:'qianzi'},
            ],
            layout:[],
            layoutcontent:[
                {"key":"jdmc","title":'酒店名称',"value:":"","class":'hotelname'},
                {"key":"djmc","title":"单据名称","value:":"预付款单","class":'hotelname'},
                {"key":"sj","title":"打印时间","value:":"","class":'hotelname'},
                {"key":"bkxm","title":"宾客姓名","value:":"","class":''},
                {"key":"xb","title":"性别","value:":"","class":''},
                {"key":"sfz","title":"身份证","value:":"","class":''},
                {"key":"jtzz","title":"家庭住址","value:":"","class":''},
                {"key":"fjhm","title":"房间号码","value:":"","class":''},
                {"key":"fj","title":"房价","value:":"","class":''},
                {"key":"fx","title":"房型","value:":"","class":''},
                {"key":"yflx","title":"用房类型","value:":"","class":''},
                {"key":"rzsj","title":"入住时间","value:":"","class":''},
                {"key":"tfsj","title":"退房时间","value:":"","class":''},
                {"key":"fkfs","title":"付款方式","value:":"","class":''},
                {"key":"je","title":"金额","value:":"","class":''},
                {"key":"dh","title":"单号","value:":"","class":''},
                {"key":"syy","title":"收银员","value:":"","class":''},
                {"key":"txfh","title":"同行房号","value:":"","class":''},
                {"key":"bz","title":"备注","value:":"","class":''},
                {"key":"yqtx","title":"友情提醒","value:":"","class":''},
                {"key":"bkqz","title":"宾客签字","value:":"","class":''},
            ],
            verticalCompact: false,
            colNum: 24, //栅格数
            rowHeight:5,
            useCssTransforms:true,
        }
    },
    created(){
        //加载配置数据 如果没有  就是默认 
        if(1 == 1){
            this.layout = this.layoutmoren; 
        }else{
            this.layout = [];//获取接口数据
            this.layoutGridItem();
        }
        this.chushihua();
    },
    methods: {
        setDayin(itemcon,index){
            if(itemcon.show){
                itemcon.show = false;
                this.layoutcontent.splice(index,1,itemcon);
                var addlay= JSON.parse(JSON.stringify(itemcon));
                if(addlay.key=='jdmc' || addlay.key=='djmc' || addlay.key=='sj'){
                    addlay.title='';
                    if(addlay.key == 'jdmc'){
                        addlay.value = this.$store.state.hotelInfo.cname;
                    }
                }
                var newlayout = {"x":0,"y":0,"w":6,"h":1,"i":addlay.key,title:addlay.title,value:addlay.value,class:addlay.class};
                this.layout.push(newlayout); 
            }
        },
        delDayin(item,index){
            this.layout.splice(index,1);
            for(var i=0;i<this.layoutcontent.length;i++){
                if(this.layoutcontent[i].key == item.i){
                    this.layoutcontent[i].show = true;
                    this.layoutcontent.splice(i,1,this.layoutcontent[i]);
                    break;
                }
            }
        },
        chushihua(){
            for(var i=0;i<this.layoutcontent.length;i++){
                this.layoutcontent[i].show = true;
                for(var j=0;j<this.layout.length;j++){
                    if(this.layoutcontent[i].key == this.layout[j].i){
                        this.layoutcontent[i].show = false;
                        this.layoutcontent.splice(i,1,this.layoutcontent[i]);
                        break;
                    }
                }  
            }
        },
        layoutGridItem(){
            let config = this.layout;
            //判断传入的参数是对象,还是数组
            if(Object.prototype.toString.call(config) == "[object Object]") {
                //校验参数
                try{
                   let xString = config.positionObj.x + ""
                   let wString = config.sizeObj.w + ""

                   //判断传入的参数是否是小数 
                   if(xString.includes(".") || wString.includes(".")) {
                        throw new Error("x 与 w参数不能是小数")
                   }

                   //判断x与w的和是否大于栅格数
                   if(config.positionObj.x + config.sizeObj.w > this.colNum) {
                       throw new Error("x 与 w之和不能大于栅格数")
                   }
                }catch(e) {
                  
                    return 
                }

                //设置新的布局格式
                this.verticalCompact = false
                this.layout.forEach(item => {
                    if(item.i == config.i) {
                        item.h = config.sizeObj.h
                        item.w = config.sizeObj.w
                        item.x = config.positionObj.x
                        item.y = config.positionObj.y
                      
                    }
                })
            }

            if(Object.prototype.toString.call(config) == "[object Array]") {
                //校验参数
                try{
                   config.forEach(_ => {
                        let xString = _.positionObj.x + ""
                        let wString = _.sizeObj.w + ""

                        //判断传入的参数是否是小数 
                        if(xString.includes(".") || wString.includes(".")) {
                                throw new Error("x 与 w参数不能是小数")
                        }

                        //判断x与w的和是否大于栅格数
                        if(_.positionObj.x + _.sizeObj.w > this.colNum) {
                            throw new Error("x 与 w之和不能大于栅格数")
                        }
                   })
                }
                catch(e) {
                  
                    return 
                }

                this.verticalCompact = false
                this.layout.forEach(item => {
                    config.forEach(_ => {
                        if(item.i == _.i) {
                            item.h = _.sizeObj.h
                            item.w = _.sizeObj.w
                            item.x = _.positionObj.x
                            item.y = _.positionObj.y
                          
                        }
                    })
                })
            }
        }
    }
}
</script>

<style  lang="scss">
    .del{
      position: absolute;
    top: 0;
    right: 0;
    width: 15px;
    height: 15px;
    font-weight: bold;
    font-size: 12px !important;;
    text-align: center;
    line-height: 15px;
    background: red;
    color: #fff;
    cursor: pointer;
    }
    .del:hover{
         transform: scale(1.1);
    }

    .checked{
        color: #cccccc !important;
    }
    .qianzi{
        font-size: 1.6em;
        font-weight: bold;
        border: 1px solid #999;
    }
    .divkey{
        height: 2em;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 6px 6px 10px #b4c9ee, -6px -6px 10px #ffffff;
        cursor: pointer;
        font-weight: normal;

        border-radius: 0.2em;
       
        color: #4bb0ff;
        line-height: 2em;
        margin: .5em 5%;
        width: 40%;
        flex-shrink: 0;
    }
    .divkey:hover{
        transform: scale(1.1);
    }
    .dayin{
        display:flex;
        padding: 2%;
        background: #e7f0ff;
    }
    .leftdiv{
        position: fixed;
        left: 0;
        width: 23%;
        height: 95%;
        overflow: auto;
        flex-wrap: wrap;
        display: flex;
        align-content: baseline;
    }
    .layout {
         width: 74%;
    position: absolute;
    left: 24%;
    height: 94%;
    overflow: auto;
    box-shadow: 8px 8px 20px #b9ccec inset, -8px -8px 15px #ffffff inset;
        padding: 0% 3%;
        line-height:40px;
    }
    .hoverStyle {
       margin-top:2%
    }
    .hotelname{
        font-size: 1.2em;
        font-weight: bold;
        text-align: center;
        border: 1px solid #999
    }
    .content{
        border: 1px solid #999;
        padding-left: 10px;
    }
</style> 